import React from 'react';

/**
 * Agent / AI sparkle — a four-point star used to mark Rudder AI affordances.
 * Uses `currentColor` so it inherits the surrounding text colour.
 */
export const Agent: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 1.5C8 4.07 9.93 6 12.5 6C9.93 6 8 7.93 8 10.5C8 7.93 6.07 6 3.5 6C6.07 6 8 4.07 8 1.5Z"
      fill="currentColor"
    />
    <path
      d="M12.5 9.5C12.5 11.16 13.34 12 15 12C13.34 12 12.5 12.84 12.5 14.5C12.5 12.84 11.66 12 10 12C11.66 12 12.5 11.16 12.5 9.5Z"
      fill="currentColor"
    />
  </svg>
);
